import React from 'react'
import { Button, Divider } from 'semantic-ui-react'
import { FileCont } from './styled'

export const FileRow1 = (props) => {

  return (
    <React.Fragment>
      <FileCont>
        <div className='titleFile1'>{`Payment Certificate / Acknowledge Doc. : `} </div>
        <div className='fileItem'>
          {
          props.interimFiles.length!==0?
          props.interimFiles.map((item,i)=>{
            // return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(item.urlPath,"_blank"))}/>
            return <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = item.urlPath)}/>
          })
          :
          <div className='noFile'>There is no attachment.</div>
        }
          <Divider />
        </div>
      </FileCont>
    </React.Fragment>
  )
}
